


















import { AppSteppers, AppSteppersPane } from '@/uikit/components/AppSteppers';
import Button from '@/components/ext/Button.vue';
import DynamicAdditionalDataForm from '@/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue';
import FinishMessage from '../parts/finishMessage';
import RequestForm from './components/RequestForm.vue';

export default {
  name: 'EventOrderProcess',
  components: {
    AppSteppersPane,
    DynamicAdditionalDataForm,
    Button,
    AppSteppers,
    RequestForm,
    FinishMessage,
  },
  data() {
    return {
      finishMsg: {},
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/event/EventOrderProcess.vue